










































































import { Component, Vue } from "vue-property-decorator";
import RepairContentList from "@/components/repair-content/repairContentList.vue";
import QTableHeader from "@/common/qTableHeader.vue";
@Component({
  name: "RepairContentPopup",
  components: {
    RepairContentList,
    QTableHeader,
  },
})
export default class RepairContentPopup extends Vue {
  public isShow = false;
  public propertyId = null;
  public floorAreaId = null;

  public headers = [
    { id: "repair_date", name: "日付", order: "desc" },
    { id: "", name: "修禅箇所" },
    { id: "", name: "内容" },
    { id: "", name: "償却残日数	" },
    { id: "", name: "備考" },
  ];

  public show(data) {
    this.propertyId = data.property_id;
    this.floorAreaId = data.floor_area_id;
    this.isShow = true;
  }
}
